import * as React from "react";
import styled from "styled-components";

const ReviewsContainer = styled.div`
  margin-top: 1rem;
`;

const ReviewsList = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 4rem;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    padding-right: 3rem;
    gap: 0rem;
    justify-content: space-between;
  }
`;

const ReviewsTitle = styled.h2`
  margin-top: 4rem;
  margin-bottom: 0px;
  font-size: 2.2rem;
  text-align: center;
`;

const Review = styled.div`
  margin-top: 1rem;
  width: 22rem;
  border: 1px solid #ccc;
  border-radius: 1rem;
  padding: 2rem;
  position: relative;
  padding-top: 5rem;
  &::before {
    content: "“";
    font-size: 6rem;
    position: absolute;
    left: 2rem;
    top: 0;
  }
  @media (max-width: 991px) {
    width: 48%;
  }
`;

export const Reviews = ({ locale, reviews }) => {
  return (<ReviewsContainer>
		<ReviewsTitle>{locale === "en" ? "Reviews" : "評論"}</ReviewsTitle>
		<ReviewsList>
			{reviews && reviews.length > 0 && reviews.map((review, index) => {
				return <Review key={index}>{review.text}</Review>
			})}
		</ReviewsList>
	</ReviewsContainer>);
};
